import '../../libs/backbone/backbone.ajaxq.adapter.ts';
import GenericView from 'views/generic.view.ts';
import Handlebars from 'handlebars';
import Template from 'text-loader!../templates/queues.template.htm';
import QueuesTable from 'text-loader!../templates/queues_table.template.htm';
import Collection from '../models/queues.paginated.collection.ts';
import 'dhtmlxMessage';
import Pagination from '../views/pagination.view.ts';
import HandlebarsHelpers from '../../libs/handlebars/handlebars-helpers.ts';
import i18n  from "l10n";
import popup from 'popup';

export default GenericView.extend({
    el: $("#container"),
    tagName: 'div',
	template: Handlebars.compile(Template),
	queuesTable: Handlebars.compile(QueuesTable),
	superInitialize: GenericView.prototype.initialize,
    collection : null,
    userData: null,
	privilegeLevel: "",
	isFirstDisplay: true,
	lastSearchedText: "",
	initialize: function (options) {
        var self = this;

        this.userData = options.data;
        this.privilegeLevel = this.privilegeLevelToNumber(this.userData.privilegeLevel);

        this.collection = new Collection();
        this.collection.url = 'rest/api/queues';
        this.collection.on( 'sync', this.successQueueData, this );
        this.collection.on( 'error', this.errorQueueData, this );
        this.collection.getFirstPage();
	},
	superRender: GenericView.prototype.render,
	render: function () {
		this.superRender();

		this.$el.html(this.template({ privilegeLevel: this.privilegeLevel }));
	},
	events: {
        "click .edit_queue": "editQueue",
        "keyup #search": "search",
        "click .open_monitor": "openMonitor",
        "click #deleteBtn": "deleteQueue"
	},
    search: function(event)
    {
        var element = $(event.currentTarget);
		var text = element.val().trim();

        if(this.lastSearchedText != text )
        {
            $.ajaxq.abort("DefaultQueue");
            this.lastSearchedText = text;
            if(i18n.lng() == "en")
                this.collection.url = 'rest/api/queues?q=' + encodeURIComponent("nameEnglish="+element.val().trim());
            else
                this.collection.url = 'rest/api/queues?q=' + encodeURIComponent("name="+element.val().trim());
            this.collection.getFirstPage();
        }
    },
    successQueueData: function()
    {
        var self = this;
        self.hideActionProgressBar();

        if(this.isFirstDisplay)
        {
            this.isFirstDisplay = false;
            this.render();
            if(this.collection.models.length == 0)
                $('#search-container').hide();
        }
        $('#table-container').html(this.queuesTable(
            {
                "queues" : this.collection.models,
                pageInfo : this.collection.info(),
                privilegeLevel: this.privilegeLevel
            })
         );

        this.pagination = new Pagination({ collection : this.collection });
        this.pagination.render();
        $( '#pagination' ).html( this.pagination.$el );

        $("#pageSize li").on("click", function() {

            var pageSize = $(this).text();

            if ( ! $(this).hasClass("active")  )
            {
                $("#pageSize li.active").removeClass("active");
                $(this).addClass("active");
                $("#pageSizeBtn").text(pageSize);
                self.collection.state.pageSize = pageSize;

                self.collection.getFirstPage();
            }

        });

        if(this.collection.models.length > 0)
        {
            $('#table-container').show();
            $('#pagination').show();
            $('#empty').hide();

            self.initializeTrs(this.showHideActionButton, "#dataTables");
        }
        else
        {
            $('#table-container').hide();
            $('#pagination').hide();
            $('#empty').show();
        }

    },
    showHideActionButton: function(flag) {
        GenericView.prototype.showHideActionButton(flag, "#deleteBtn", "#dataTables");
    },
    errorQueueData: function(collection, xhr, options)
    {
        this.onErrorHandler(collection, xhr, options);
    },
	editQueue: function(e) {
	    window.location.href = "#Queue/"+$(e.currentTarget).parent().data("id");
	},
    deleteQueue: function() {

        var self = this;

        var ids = "";
        $("#dataTables").find("td input:checked").each( function() {
            ids += ($(this).parent().data("id")) +",";
        });

        var url = 'rest/api/queues?ids=' + ids;

        var params = {
            "url": url,
            "collection": this.collection,
             "_showProgressBar": self.showActionProgressBar,
             "_hideProgressBar": self.hideActionProgressBar,
             "_deleteBtn": $('#deleteBtn')
        }
        popup.show(i18n.t("pageHeader.confirm_delete"), i18n.t("pageHeader.delete_msg"), "confirm_delete", params);

    },
	openMonitor: function(e)
	{
	    window.location.href = "#QueueMonitor/"+$(e.currentTarget).parent().data("id");
	}

});

